export const SOCKET_URL = process.env.SOCKET_URL || "https://apigametime.internationalschool.global"  // "https://apigametime.internationalschool.global";